/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

#card-injury-cause {
  .symptoms-list {
    min-width: 300px;

    // Removes button styles. Element was previously a div, but mouse event listeners
    // on native elements are a code smell for accessibility reasons
    background-color: inherit;
    border: none;
  }

  .burn-scald-input {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 16px 16px;

    .grade,
    .percentage {
      width: 100px;
    }
  }
}
